export default __webpack_public_path__ + "static/media/homeIcon.a6d5ef71.svg";